// Static product catalogue. All sugar from Colombia (Manuelita-style refineries).
// Coffee from Colombia/Peru, Cocoa from Ecuador/Peru/Dominican Republic.
export const PRODUCTS = [
  {
    code: "white_sugar",
    image:
      "https://images.unsplash.com/photo-1634612831148-03a8550e1d52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxyYXclMjBjYW5lJTIwc3VnYXJ8ZW58MHx8fHwxNzgxNDMyMTQ3fDA&ixlib=rb-4.1.0&q=85",
    icao: "ICUMSA 45",
    origin: { it: "Colombia", en: "Colombia", es: "Colombia" },
    titles: {
      it: "Zucchero di canna bianco raffinato",
      en: "Refined white cane sugar",
      es: "Azúcar de caña blanca refinada",
    },
    descriptions: {
      it: "ICUMSA 45 dalle raffinerie selezionate della Valle del Cauca. Disponibile in big bag e sacchi da 50 kg.",
      en: "ICUMSA 45 from selected mills in Colombia's Valle del Cauca. Available in big bags and 50 kg bags.",
      es: "ICUMSA 45 de ingenios seleccionados del Valle del Cauca. Disponible en big bag y sacos de 50 kg.",
    },
    packaging: {
      it: "Big bag 1.000 kg / Sacchi 50 kg",
      en: "Big bag 1,000 kg / 50 kg bags",
      es: "Big bag 1.000 kg / Sacos 50 kg",
    },
    moq: "25 MT",
    specs: ["ICUMSA 45", "Polarisation 99.8°", "Moisture < 0.04%"],
    colSpan: "md:col-span-7",
  },
  {
    code: "brown_sugar",
    image:
      "https://images.unsplash.com/photo-1704079611177-a3a60ce6f975?w=1200&auto=format&fit=crop&q=80",
    icao: "VHP Raw",
    origin: { it: "Colombia", en: "Colombia", es: "Colombia" },
    titles: {
      it: "Zucchero di canna grezzo (brown)",
      en: "Brown raw cane sugar",
      es: "Azúcar de caña morena (brown)",
    },
    descriptions: {
      it: "Zucchero VHP e Demerara colombiano per industria dolciaria, bevande e retail premium. Note caramellate naturali da melassa residua.",
      en: "Colombian VHP and Demerara cane sugar for confectionery, beverage and premium retail use. Natural caramel notes from residual molasses.",
      es: "Azúcar colombiano VHP y Demerara para confitería, bebidas y retail premium. Notas naturales de caramelo por la melaza residual.",
    },
    packaging: {
      it: "Big bag 1.000 kg / Sacchi 50 kg",
      en: "Big bag 1,000 kg / 50 kg bags",
      es: "Big bag 1.000 kg / Sacos 50 kg",
    },
    moq: "25 MT",
    specs: ["ICUMSA 600–1200", "Polarisation 99.4°", "Moisture < 0.15%"],
    colSpan: "md:col-span-5",
  },
  {
    code: "organic_sugar",
    image:
      "https://images.unsplash.com/photo-1586794234236-efd0ffb207b2?w=1200&auto=format&fit=crop&q=80",
    icao: "Organic · Premium",
    origin: { it: "Colombia", en: "Colombia", es: "Colombia" },
    titles: {
      it: "Zucchero di canna biologico pregiato",
      en: "Premium organic cane sugar",
      es: "Azúcar de caña orgánica premium",
    },
    descriptions: {
      it: "Filiera completamente biologica certificata EU Organic e USDA. Zucchero di canna integrale e raffinato, ottenuto senza pesticidi né residui chimici, da piantagioni a basso impatto.",
      en: "Fully organic supply chain, certified EU Organic and USDA. Whole and refined cane sugar produced without pesticides or chemical residues, from low-impact plantations.",
      es: "Cadena 100% orgánica certificada EU Organic y USDA. Azúcar de caña integral y refinada sin pesticidas ni residuos químicos, de plantaciones de bajo impacto.",
    },
    packaging: {
      it: "Big bag 1.000 kg / Sacchi 25/50 kg",
      en: "Big bag 1,000 kg / 25–50 kg bags",
      es: "Big bag 1.000 kg / Sacos 25/50 kg",
    },
    moq: "20 MT",
    specs: ["EU Organic", "USDA Organic", "Fairtrade ready"],
    colSpan: "md:col-span-5",
  },
  {
    code: "coffee",
    image:
      "https://images.unsplash.com/photo-1652015496419-58606c1b5d1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxjb2ZmZWUlMjBwbGFudGF0aW9uJTIwc291dGglMjBhbWVyaWNhfGVufDB8fHx8MTc4MTQzMjE0N3ww&ixlib=rb-4.1.0&q=85",
    icao: "Arabica",
    origin: { it: "Colombia / Perù", en: "Colombia / Peru", es: "Colombia / Perú" },
    titles: {
      it: "Caffè verde Arabica",
      en: "Green Arabica coffee",
      es: "Café verde Arábica",
    },
    descriptions: {
      it: "Lotti washed e natural da Huila, Nariño, Antioquia (Colombia) e Cajamarca (Perù). SCA cupping ≥ 82, screen 15+.",
      en: "Washed and natural lots from Huila, Nariño, Antioquia (Colombia) and Cajamarca (Peru). SCA cupping ≥ 82, screen 15+.",
      es: "Lotes washed y natural de Huila, Nariño, Antioquia (Colombia) y Cajamarca (Perú). SCA cupping ≥ 82, screen 15+.",
    },
    packaging: {
      it: "Sacchi juta 60/69 kg",
      en: "Jute bags 60/69 kg",
      es: "Sacos de yute 60/69 kg",
    },
    moq: "19,2 MT (1 FCL 20')",
    specs: ["SCA cup ≥ 82", "Moisture 10–12%", "Screen 15/16/17"],
    colSpan: "md:col-span-7",
  },
  {
    code: "cocoa",
    image:
      "https://images.unsplash.com/photo-1573710661345-610f790e1218?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjb2NvYSUyMHBvZHMlMjByYXd8ZW58MHx8fHwxNzgxNDMyMTQ3fDA&ixlib=rb-4.1.0&q=85",
    icao: "Fino de aroma",
    origin: {
      it: "Ecuador / Perù / Rep. Dominicana",
      en: "Ecuador / Peru / Dominican Rep.",
      es: "Ecuador / Perú / Rep. Dominicana",
    },
    titles: {
      it: "Fave di cacao",
      en: "Cocoa beans",
      es: "Granos de cacao",
    },
    descriptions: {
      it: "Cacao Nacional 'Fino de aroma', CCN-51 e Hispaniola — fermentazione 5–7 giorni, essiccazione al sole.",
      en: "Nacional 'Fino de aroma', CCN-51 and Hispaniola cocoa — 5–7 day fermentation, sun-dried.",
      es: "Cacao Nacional 'Fino de aroma', CCN-51 e Hispaniola — fermentación 5–7 días, secado al sol.",
    },
    packaging: {
      it: "Sacchi juta 65 kg",
      en: "Jute bags 65 kg",
      es: "Sacos de yute 65 kg",
    },
    moq: "12,5 MT",
    specs: ["Fermentation ≥ 75%", "Moisture < 7.5%", "Bean count 95–105 / 100 g"],
    colSpan: "md:col-span-12",
  },
];

export const PRODUCT_BY_CODE = Object.fromEntries(PRODUCTS.map((p) => [p.code, p]));
